
import React from 'react';
import { FlowRender } from "../flow-render";
import { RadioButton, RADIO_SINGLE_RANDOM_VALUE } from "../prm/radio-button";
import { Name } from "../prm/name";
import {Text} from "../prm/text";
import {set_access_funds_ira, set_access_funds_ugma} from "./risk_0";
import { GreyBox } from "../../client/funcs/utils";
import {is_ira, is_ugma} from "../onboarding-utils";

const title = "A few questions if you're involved in the investment industry:";
const text_0 = "Are you affiliated with, or employed by a stock exchange or " +
  "member firm of an exchange or FINRA or a municipal securities broker-dealer?";

const role_0_is_affiliated_finra = new RadioButton(
  new Name("role_0_is_affiliated_finra"),
  [
    new Name("no", "No"),
    new Name("yes", "Yes"),
  ], [], RADIO_SINGLE_RANDOM_VALUE);
const role_0_affiliated_finra_company = new Text(
  new Name("role_0_affiliated_finra_company"), null, { path: "company.companyName" })

const text_1 = "Are you a director, 10% shareholder, or " +
  "policy-maker of a publicly held company?";

const role_0_is_affiliated_public_company = new RadioButton(
  new Name("role_0_is_affiliated_public_company"),
  [
    new Name("no", "No"),
    new Name("yes", "Yes"),
  ], [], RADIO_SINGLE_RANDOM_VALUE);
const role_0_affiliated_public_company = new Text(
  new Name("role_0_affiliated_public_company"), null, { path: "company.companyName" })


class FinraAffiliation extends FlowRender {

  constructor(index) {
    super(index, [
      role_0_is_affiliated_finra,
      role_0_affiliated_finra_company,
      role_0_is_affiliated_public_company,
      role_0_affiliated_public_company,
    ]);
    role_0_is_affiliated_finra.onChangeCallback = this.onChange;
    role_0_affiliated_finra_company.onAction = this.onTextEdit;
    role_0_is_affiliated_public_company.onChangeCallback = this.onChange;
    role_0_affiliated_public_company.onAction = this.onTextEdit;
    this.url = "finra_affiliation";
  }

  canNavigateNext(component) {
    const state = component.state;
    const highlight_rects = [];

    if (role_0_is_affiliated_finra.isFilledElseHighlight(state, highlight_rects)) {
      const is_yes = role_0_is_affiliated_finra.isSelected(state, 1);
      if (!is_yes ||
        (is_yes
          && role_0_affiliated_finra_company.isFilledElseHighlight(state, highlight_rects))) {}
    }
    if (role_0_is_affiliated_public_company.isFilledElseHighlight(state, highlight_rects)) {
      const is_yes = role_0_is_affiliated_public_company.isSelected(state, 1);
      if (!is_yes
        || (is_yes
          && role_0_affiliated_public_company.isFilledElseHighlight(state, highlight_rects))) {}
    }

    if (highlight_rects.length) {
      component.setState({highlight_rects});
      return null;
    }

    const onboarding = component.getOnboardingData();
    if (is_ira(onboarding)) {
      const new_onboarding = set_access_funds_ira(onboarding.role_0_dob);
      component.writeIfDirty(new_onboarding);

      return component.getRootUrl() + "/risk_1";
    } else if (is_ugma(onboarding)) {
      // Access in 30, spend in 30
      component.writeIfDirty(set_access_funds_ugma());
      return component.getRootUrl() + "/risk_1";
    }

    return component.getRootUrl() + "/risk_0";
  }

  onTextEdit = component => {
    const newState = Object.assign({}, component.state);
    this.onChange(component, newState);
    component.setState(newState);
  }

  renderBody_2 = component => {
    // const checkbox_style = {
    //   marginTop: "0.25rem"
    // };
    const input_style = {
      width: "100%",
    }
    const show_company = role_0_is_affiliated_public_company.isItemClicked(1, component.state);
    const public_company = show_company ? (
        <div style={{paddingBottom: "1rem", paddingLeft: "0", paddingRight: "0"}}>
          { role_0_affiliated_public_company.renderInputDiv(component, input_style, "Company Name") }
        </div>)
      : null;

    return (
      <div>
        <div style={{height: "4rem"}}/>
        <div>{text_1}</div>
        <div style={{height: "1rem"}}/>
        <GreyBox>
          <div style={{ paddingBottom: "1rem", width: 'fit-content' }}>
            {/* { role_0_is_affiliated_public_company.renderCheckbox(0, component, checkbox_style) }
            { role_0_is_affiliated_public_company.renderLabel(0, component.state) } */}
            { role_0_is_affiliated_public_company.renderRadioLabel(0, component)}
          </div>
          <div style={{ paddingBottom: "1rem", width: 'fit-content' }}>
            {/* { role_0_is_affiliated_public_company.renderCheckbox(1, component, checkbox_style) }
            { role_0_is_affiliated_public_company.renderLabel(1, component.state) } */}
            { role_0_is_affiliated_public_company.renderRadioLabel(1, component)}
          </div>
          { public_company }
        </GreyBox>
      </div>
    );
  };


  renderBody = component => {
    const box_container = {
      paddingBottom: "1rem",
      width: 'fit-content'
    };
    // const checkbox_style = {
    //   marginTop: "0.25rem",
    // };
    const input_div = {
      width: "100%",
    }
    const show_company = role_0_is_affiliated_finra.isItemClicked(1, component.state);
    const finra = show_company ? (
      <div style={{paddingBottom: "1rem", paddingLeft: "0", paddingRight: "0"}}>
        { role_0_affiliated_finra_company.renderInputDiv(component, input_div, "Company Name") }
      </div>)
      : null;

    return (
      <div>
        <div style={{fontSize: "1.5rem"}}>{title}</div>
        <div style={{height: "1rem"}}/>
        <div>{text_0}</div>
        <div style={{height: "1rem"}}/>
        <GreyBox>
          <div style={box_container}>
            {/* { role_0_is_affiliated_finra.renderCheckbox(0, component, checkbox_style)}
            { role_0_is_affiliated_finra.renderLabel(0, component.state)} */}
            { role_0_is_affiliated_finra.renderRadioLabel(0, component)}
          </div>
          <div style={box_container}>
            {/* { role_0_is_affiliated_finra.renderCheckbox(1, component, checkbox_style)}
            { role_0_is_affiliated_finra.renderLabel(1, component.state)} */}
            { role_0_is_affiliated_finra.renderRadioLabel(1, component)}
          </div>
          { finra }
        </GreyBox>
        { this.renderBody_2(component) }
      </div>
    )
  };

  render = component => {
    return (
      <div>
        { this.renderHighlightRects(component) }
        { this.renderTitle(component, "Industry Connections", "50%", "952140135")}
        { this.renderProgress(component) }
        { this.renderSingleColumn(this.renderBody(component), "50%")}
        { this.renderNextButtonRow(component, true) }
      </div>
    )
  }
}

export { FinraAffiliation, text_0 };
